import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    company: '',
    country: '',
    message: ''
  });

  const [isHuman, setIsHuman] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
    console.log('Form submitted:', formData);
  };

  return (
    <section className="newsletter-section" id="contact">
      <div className="newsletter-container">
        <div className="newsletter-content">
          <h2 className="newsletter-title">We’re here to help</h2>
          <p className="newsletter-description">
            Fill in the form below and our team at Belageri Technologies will get back to you shortly.
          </p>

          <form className="newsletter-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <input
                  type="text"
                  name="firstName"
                  placeholder="First name *"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  className="form-input"
                  required
                />
              </div>
              <div className="form-group">
                <input
                  type="text"
                  name="lastName"
                  placeholder="Last name *"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  className="form-input"
                  required
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Email *"
                  value={formData.email}
                  onChange={handleInputChange}
                  className="form-input"
                  required
                />
              </div>
              <div className="form-group">
                <input
                  type="text"
                  name="company"
                  placeholder="Company *"
                  value={formData.company}
                  onChange={handleInputChange}
                  className="form-input"
                  required
                />
              </div>
            </div>

            <div className="form-row country-message-row">
              <div className="left-column">
                <div className="form-group">
                  <select
                    name="country"
                    value={formData.country}
                    onChange={handleInputChange}
                    className="form-select"
                    required
                  >
                    <option value="" disabled>Country *</option>
                    <option value="usa">United States</option>
                    <option value="canada">Canada</option>
                    <option value="uk">United Kingdom</option>
                    <option value="australia">Australia</option>
                    <option value="germany">Germany</option>
                    <option value="france">France</option>
                    <option value="india">India</option>
                    <option value="japan">Japan</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                {/* Desktop captcha - hidden on mobile (480px and below) */}
                <div className="captcha-section desktop-captcha">
                  <div className="captcha-container">
                    <label className="captcha-label">
                      <input
                        type="checkbox"
                        checked={isHuman}
                        onChange={(e) => setIsHuman(e.target.checked)}
                        className="captcha-checkbox"
                        required
                      />
                      <span className="checkmark"></span>
                      I am human
                    </label>
                    <div className="captcha-logo">
                      <div className="recaptcha-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                          <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z" fill="#4285F4"/>
                        </svg>
                      </div>
                      <div className="recaptcha-text">
                        <div className="recaptcha-title">reCAPTCHA</div>
                        <div className="recaptcha-privacy">Privacy - Terms</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="right-column">
                <div className="form-group">
                  <textarea
                    name="message"
                    placeholder="Message *"
                    value={formData.message}
                    onChange={handleInputChange}
                    className="form-input form-textarea"
                    rows="6"
                    required
                  />
                </div>
              </div>

              {/* Mobile captcha - shown only on mobile (480px and below) */}
              <div className="captcha-section mobile-captcha">
                <div className="captcha-container">
                  <label className="captcha-label">
                    <input
                      type="checkbox"
                      checked={isHuman}
                      onChange={(e) => setIsHuman(e.target.checked)}
                      className="captcha-checkbox"
                      required
                    />
                    <span className="checkmark"></span>
                    I am human
                  </label>
                  <div className="captcha-logo">
                    <div className="recaptcha-icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z" fill="#4285F4"/>
                      </svg>
                    </div>
                    <div className="recaptcha-text">
                      <div className="recaptcha-title">reCAPTCHA</div>
                      <div className="recaptcha-privacy">Privacy - Terms</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <button type="submit" className="submit-btn" disabled={!isHuman}>
              Send Message
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M5 12h14m-7-7l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </form>
        </div>
      </div>

      {/* Footer section with dark blue background pinned to bottom */}
      <div className="form-footer-section">
        <div className="form-footer-container">
          <p className="mandatory-text">
            <span className="asterisk">*</span> Mandatory field
          </p>
          <p className="privacy-text">
            When you submit this form, our specialist will be in touch with you by email or telephone.
            By submitting the form you accept our <a href="#" className="privacy-link">privacy statement</a>.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Contact;
